module.exports = __webpack_public_path__ + "img/es-pv.c3050ef4.svg";